module.exports = __webpack_public_path__ + "img/seminar-inactive.9cd41be7.png";